export default __webpack_public_path__ + "static/media/projects-icon.b6ae1bb1.svg";